const jobpostexamples = (() => {
    const supportedLocales = [
        'en-US', 'de-DE', 'en-GB', 'fr-FR', 'es-419', 'ja-JP', 'it-IT', 'pt-BR', 'zh-CN'
    ];

    const getLocale = () => {
        const lang = getLanguage();
        return supportedLocales.includes(lang) ? lang : 'en-US';
    };


    let linkTarget = '_self';

    const loadExamples = async () => {
        const locale = getLocale();
        try {
            const res = await fetch(`/dist/custom/js/data/examples/jobpostexamples.${locale}.html`);
            const html = await res.text();
            renderExamples(html, locale);
        } catch (err) {
            console.error('Failed to load job post examples:', err);
        }
    };

    const renderExamples = (htmlContent, locale) => {
        const container = document.getElementById('jobpostexamples-grid');
        if (!container) return;
        container.innerHTML = '';

        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');
        const examples = Array.from(doc.body.children).filter(el => el.classList.contains('jobpostexample-item'));


        examples.forEach((example, i) => {
            const heading = document.createElement('h4');
            heading.className = 'example-heading';
            heading.textContent = getI18n('Example' + (i+1));
            container.appendChild(heading);
            container.appendChild(example);
        });
    };

    const init = (target = '_self') => {
        linkTarget = target;
        loadExamples();
    };

    return { init };
})();

export default jobpostexamples;
